import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    user: (() => {
        try {
            return JSON.parse(localStorage.getItem("user"));
        } catch {
            localStorage.removeItem("user");
            return null;
        }
    })(),
    loading: false,
    darkTheme: true
};

const profileSlice = createSlice({
    name: "profile",
    initialState: initialState,
    reducers: {
        setUser(state, value) {
            state.user = value.payload;
        },
        setLoading(state, value) {
            state.loading = value.payload;
        },
        setDarkTheme(state, value) {
            state.darkTheme = value.payload
        }
    },
});

export const { setUser, setLoading, setDarkTheme } = profileSlice.actions;
export default profileSlice.reducer;